import { getLocation } from './getLocation';
export function appendQuery(url, query) {
    if (!url || !query) {
        return url;
    }
    var location = getLocation(url);
    if (!location) {
        return url;
    }
    var protocol = location.protocol, hostname = location.hostname, port = location.port, path = location.path, search = location.search, hash = location.hash;
    return "".concat(protocol, "//").concat(hostname).concat(port ? ':' + port : '').concat(path).concat(search ? search + '&' : '?').concat(query).concat(hash);
}
//# sourceMappingURL=appendQuery.js.map